import { pushEvent } from './pushEvent';

export function pushWciClickedEvent(pnr, ref) {
  pushEvent({ event: 'wci_clicked', data: { booking_reference: pnr, ref } });
}


